<section class="stacked-card w-full overflow-hidden max-sm:h-screen-safe max-sm:w-screen-safe">
  <header class="flex items-center justify-between gap-3 border-b border-neutral-grey-200 p-4">
    <div class="flex flex-col">
      <h2 class="text-sm font-normal text-neutral-grey-950">
        Meldingen
      </h2>
      <p class="text-xs font-normal text-neutral-grey-700">
        {{ totalUnreadNotifications() }} ongelezen meldingen
      </p>
    </div>
    @if (totalUnreadNotifications() > 0) {
    <div class="sm:pr-2">
      <button type="button" class="btn-hyperlink justify-start text-casper-700 sm:justify-center"
        (click)="markAllAsRead()">
        Markeer alles als gelezen
      </button>
    </div>
    }
  </header>

  <div class="relative min-h-0 max-sm:flex-1">
    <div class="no-scrollbar overflow-y-auto pb-16 max-sm:h-full max-sm:max-h-full sm:max-h-96">
      @for (notification of notifications(); track notification.id) {
      <app-notification-item [notification]="notification"></app-notification-item>
      } @empty {
      <div class="flex flex-col items-center gap-3 px-6 py-10 text-center">
        <app-avatar variant="icon" icon="line-md:bell-twotone-loop"></app-avatar>
        <div class="flex flex-col gap-1">
          <h3 class="text-sm font-medium text-neutral-grey-950">
            Je bent helemaal bij
          </h3>
          <p class="text-sm font-normal text-neutral-grey-700">
            Er zijn geen nieuwe meldingen.
          </p>
        </div>
      </div>
      }
    </div>
    <div class="scroll-fade-bottom"></div>
  </div>
</section>
